import { Note } from "./Note";

export class NotesListSection {
    private _header: string = "";
    private _items: Note[] = [];
    private _expanded: boolean = true;

    constructor(header: string, items: Note[], expanded: boolean) {
        this._header = header;
        this._items = items;
        this._expanded = expanded;
    }

    get header() {
        return this._header;
    }

    get items() {
        return this._items;
    }

    get expanded() {
        return this._expanded;
    }

    expand() {
        this._expanded = true;
    }

    collapse() {
        this._expanded = false;
    }

    toggle() {
        this._expanded = !this._expanded;
    }
}
